export const countryPrefixes = [
    { name: "España", dialCode: "+34", code: "ES" },
    { name: "EEUU", dialCode: "+1", code: "US" },
    { name: "México", dialCode: "+52", code: "MX" },
    { name: "Argentina", dialCode: "+54", code: "AR" },
    { name: "Colombia", dialCode: "+57", code: "CO" },
    { name: "Chile", dialCode: "+56", code: "CL" },
    { name: "Perú", dialCode: "+51", code: "PE" },
    { name: "Venezuela", dialCode: "+58", code: "VE" },
    { name: "Ecuador", dialCode: "+593", code: "EC" },
    { name: "Bolivia", dialCode: "+591", code: "BO" },
    { name: "Paraguay", dialCode: "+595", code: "PY" },
    { name: "Uruguay", dialCode: "+598", code: "UY" },
    { name: "Brasil", dialCode: "+55", code: "BR" },
    { name: "Portugal", dialCode: "+351", code: "PT" },
    { name: "Francia", dialCode: "+33", code: "FR" },
    { name: "Alemania", dialCode: "+49", code: "DE" },
    { name: "Italia", dialCode: "+39", code: "IT" },
    { name: "R.Unido", dialCode: "+44", code: "GB" },
    { name: "Irlanda", dialCode: "+353", code: "IE" },
    { name: "Bélgica", dialCode: "+32", code: "BE" },
    { name: "P.Bajos", dialCode: "+31", code: "NL" },
    { name: "Suiza", dialCode: "+41", code: "CH" },
    { name: "Suecia", dialCode: "+46", code: "SE" },
    { name: "Noruega", dialCode: "+47", code: "NO" },
    { name: "Dinamarca", dialCode: "+45", code: "DK" },
    { name: "Finlandia", dialCode: "+358", code: "FI" },
    { name: "Rusia", dialCode: "+7", code: "RU" },
    { name: "China", dialCode: "+86", code: "CN" },
    { name: "Japón", dialCode: "+81", code: "JP" },
    { name: "Corea del Sur", dialCode: "+82", code: "KR" },
    { name: "India", dialCode: "+91", code: "IN" },
    { name: "Australia", dialCode: "+61", code: "AU" },
    { name: "Canadá", dialCode: "+1", code: "CA" },
    { name: "N.Zelanda", dialCode: "+64", code: "NZ" },
    { name: "Sudáfrica", dialCode: "+27", code: "ZA" },
    { name: "Egipto", dialCode: "+20", code: "EG" },
    { name: "Marruecos", dialCode: "+212", code: "MA" },
    { name: "Turquía", dialCode: "+90", code: "TR" },
    { name: "A.Saudita", dialCode: "+966", code: "SA" },
    { name: "EAU", dialCode: "+971", code: "AE" },
    { name: "Israel", dialCode: "+972", code: "IL" }
];